import { ReactComponent as ArrowDown } from "ressources/icons/landing/arrow-down.svg";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import "./style.css";

import { useAppSelector } from "store";
import { selectCurrentUserId } from "_utils/slices/authSlice";

const Header = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const userId = useAppSelector(selectCurrentUserId);

  return (
    <div className="landing-header">
      <div className="landing-header-media">
        <img
          className="landing-header-image"
          src="/media/hero.png"
          alt=""
        />
        <div className="landing-header-overlay" />
      </div>

      <div className="landing-header-content">
        <div className="landing-header-left">
          <div className="title-landing">
            {t('landing-main1')}
          </div>
          <div className="description-landing">
            <div className="description-landing-first">
              {t('landing-main2')}
            </div>
            <div className="description-landing-second">
              {t('landing-main3')}
            </div>
          </div>
          <div className="buttons-landing">
            {userId ? (
              <div
                className="button-landing button-gradient bg-gradient-blue"
                onClick={() => {
                  navigate("/login");
                  window.fathom?.trackGoal('VLODRIYH', 0);
                }}
              >
                {t('my-desk')}
              </div>
            ) : (
              <>
                <div
                  className="button-landing"
                  onClick={() => navigate("/login")}
                >
                  {t('i-login')}
                </div>
                <div
                  className="button-landing button-gradient bg-gradient-blue"
                  onClick={() => navigate("/signup")}
                >
                  {t('i-signup')}
                </div>
              </>
            )}
          </div>
          {!userId && <div className="button-description">
            {t('no-cb')}
          </div>}
        </div>
      </div>

      <ArrowDown
        onClick={() =>
          document
            .getElementsByClassName("main-landing")[0]
            ?.scrollIntoView({ behavior: "smooth" })
        }
        className="arrow-bottom"
      />
    </div>
  );
};

export default Header;
